export default [
  {
    key: "firstName",
    label: "field.firstName",
    type: "text",
    disabled: true,
  },
  {
    key: "lastName",
    label: "field.lastName",
    type: "text",
    disabled: true,
  },
  {
    key: "email",
    label: "field.email",
    type: "text",
    disabled: true,
  },
  {
    key: "phone",
    label: "field.phone",
    type: "text",
    disabled: true,
    hiddenKey: "isBot",
    hiddenValue: true,
  },
  // {
  //   key: "totalServiceCap",
  //   label: "field.serviceCap",
  //   type: "number",
  //   rules: "required",
  //   icon: "icon",
  //   hiddenKey: "isBot",
  //   hiddenValue: true,
  // },
  {
    key: "serviceCap",
    label: "general.chat_cap",
    type: "number",
    rules: "required",
    icon: "icon",
    hiddenKey: "isBot",
    hiddenValue: true,
  },
  {
    key: "roleId",
    label: "field.role",
    rules: "required",
    type: "async-single-selection",
    repository: "role",
    selectionKey: "id",
    selectionLabel: "translations",
    hiddenKey: "isBot",
    hiddenValue: true,
  },
  {
    key: "newPassword",
    placeholder: "placeholder.password",
    label: "field.newPassword",
    rules: "min:6",
    type: "password",
    cols: 6,
    hiddenKey: "isBot",
    hiddenValue: true,
  },
  {
    key: "retypeNewPassword",
    label: "field.retypeNewPassword",
    placeholder: "placeholder.password",
    rules: "confirmed:newPassword",
    type: "password",
    cols: 6,
    hiddenKey: "isBot",
    hiddenValue: true,
  },
  {
    key: "supportedCallLanguages",
    label: "field.localeCode",
    type: "multi-selection",
    selectionKey: "language",
    reduce: true,
    cols: 6,
    options: [],
  },
  {
    key: "isActive",
    label: "field.status",
    type: "radio",
    rules: "required",
    options: [
      { text: "status.active", value: "1" },
      { text: "status.inactive", value: "0" },
    ],
    cols: 6,
  },
];
